<!-- eslint-disable -->
@if ((totalScans$ | async) > 0) {
  <div id="scan-session-review">
    <mat-card appearance="outlined">
      <div>
        Document processing in progress.
        (<span id="progress-completed">{{(completedScans$ | async)}}</span> / <span id="progress-total">{{(totalScans$ | async)}} pages</span>)
        <mat-progress-bar
          mode="determinate"
          value="{{(completedScans$ | async) / (totalScans$ | async) * 100}}"
          aria-label="Document processing progress">
        </mat-progress-bar>
      </div>
    </mat-card>
    <eca-results-list
      [successful]="successful$ | async"
      [failures]="failures$ | async"
      [processing]="processing$ | async"
      [isDoneProcessingScans]="(scansCompleted$ | async)">
    </eca-results-list>
    @if ((isPolling$ | async) || (hasSuccessfulDocuments$ | async) || (hasFailedDocuments$ | async)) {
      <mat-card
        appearance="outlined"
        >
        @if ((isPolling$ | async) && !(scansCompleted$ | async)) {
          <eca-app-alert
            icon="info"
            type="info"
            text="Please wait while your documents process.">
          </eca-app-alert>
        }
        @if ((isPolling$ | async) && (scansCompleted$ | async)) {
          <eca-app-alert
            icon="info"
            type="info"
            text="Finalizing documents; almost done.">
          </eca-app-alert>
        }
        @if (!(isPolling$ | async)) {
          <div>
            @if ((hasSuccessfulDocuments$ | async)) {
              <eca-app-alert
                icon="check_circle"
                type="success"
                text="Document processing is complete. Please review your documents for submission in the Submit and Alert links at the top of this page.">
              </eca-app-alert>
            }
            @if ((hasFailedDocuments$ | async)) {
              <eca-app-alert
                icon="error"
                type="error"
                text="There were errors with some documents. You may set those aside and continue with the successfully scanned documents. The failed documents may be re-scanned later.">
              </eca-app-alert>
            }
            @for (error of errors$ | async; track error) {
              <eca-app-alert
                icon="error"
                type="warning"
                [text]="error">
              </eca-app-alert>
            }
          </div>
        }
      </mat-card>
    }
  </div>
}

